import BaseModel from '@/models/list/base';

export default class EventPage extends BaseModel {
  constructor(page) {
    super(page);

    this.cards = page.cards || [];
    this.data = page.data || {};
    this.image = page.image || [];
    this.sort_order = page.sort_order || 1;
    this.type = page.type;
    this.video = page.video || [];
  }
}
